import React from 'react';
import SubjectPage from '../../Subjects/SubjectPage';

function Flashcard() {

    const pageTitleText = "JEE Flashcard ";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="flashcard" 
      />

    </>
  );
}

export default Flashcard;